import { Controller } from "@hotwired/stimulus"

// Авто-фильтр списка табелей. Контроллер навешен на <form> (GET, turbo_frame).
// datepicker (поля С/ПО) и select2 (объект) диспатчат bubbling-событие change,
// которое всплывает до формы — здесь оно ловится и сабмитит форму.
// Результаты обновляются только во фрейме timesheets_results.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
